import script from "./FormInvoice.vue?vue&type=script&setup=true&lang=js"
export * from "./FormInvoice.vue?vue&type=script&setup=true&lang=js"

import "./FormInvoice.vue?vue&type=style&index=0&id=4675bd75&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4675bd75"]])

export default __exports__